module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "7",
      "height": "7",
      "viewBox": "0 0 7 7",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_2016_70907)"
    }
  }, [_c('rect', {
    attrs: {
      "width": "6.0025",
      "height": "6.0015",
      "rx": "3.00075",
      "fill": "#979797"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_2016_70907"
    }
  }, [_c('rect', {
    attrs: {
      "width": "6.0025",
      "height": "6.0015",
      "rx": "3.00075",
      "fill": "979797"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b65c5b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/GrayDot.vue
// module id = 1502
// module chunks = 159